module.exports = __webpack_public_path__ + "static/media/condominium.b2cf57ec.svg";